

import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { CourseListResponse, getCourses } from "../../../../api/courses";

interface UseCBTListParams {
  initialPage?: number;
  initialLimit?: number;
  isAdmin?: boolean;
}

export const useCBTList = ({
  initialPage = 1,
  initialLimit = 10,
  isAdmin = true,
}: UseCBTListParams) => {
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setPage(1);
  }, [search]);

  const responseQuery = useQuery<CourseListResponse>({
    queryKey: ["admin-cbt", { page, limit, search }],
    queryFn: () => getCourses({ page, limit, search, type: 'CBT' }, isAdmin),
    refetchInterval: 60000,
    refetchIntervalInBackground: true,
  });

  const onPaginationChange = (pagination: { current: number; pageSize: number }) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  return {
    ...responseQuery,
    page,
    limit,
    search,
    setSearch,
    onPaginationChange,
  };
};